import React from 'react';
import PropTypes from 'prop-types';

const Branding = ( props ) => {

		return (
			<div>
				{ props.children }
			</div>
		);

	};
Branding.propTypes = {
	children: PropTypes.oneOfType( [
		PropTypes.arrayOf( PropTypes.node ),
		PropTypes.node
	] )
};
export default Branding;
